import React from "react";
import "./PageCss/Clients.css";

const clients = [
  {
    name: "Acme Corp",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg",
    view: "Techit delivered our project on time with outstanding quality. Their UI/UX expertise is top-notch.",
    person: "Ashim Subedi, CTO"
  },
  {
    name: "FinTechly",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/facebook/facebook-original.svg",
    view: "We loved working with TechBit! The team is creative, responsive, and truly cares about our success.",
    person: "Ajay Regmi, Product Lead"
  },
  {
    name: "EduLearn",
    logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg",
    view: "The platform they built for us is robust and beautiful. Highly recommended for any digital project.",
    person: "Anup Regmi, CEO"
  }
];

const recentWorks = [
  {
    title: "Smart Dashboard",
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80",
    client: "Acme Corp"
  },
  {
    title: "Mobile Banking App",
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=400&q=80",
    client: "FinTechly"
  },
  {
    title: "E-learning Portal",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=400&q=80",
    client: "EduLearn"
  }
];

export default function OurClients() {
  return (
    <section className="clients-section" data-aos="fade-up">
      <div className="container">
        <h2 className="clients-title">Our Recent Work</h2>
        <p className="clients-subtitle">
          We partner with forward-thinking brands to create impactful digital experiences.
        </p>

        {/* Recent Works Grid */}
        <div className="works-grid">
          {recentWorks.map((work, idx) => (
            <div className="work-card" key={idx} data-aos="zoom-in" data-aos-delay={100 * (idx + 1)}>
              <img src={work.image} alt={work.title} className="work-image" />
              <div className="work-info">
                <h4>{work.title}</h4>
                <span className="work-client">{work.client}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Client Logos
        <div className="clients-logos">
          {clients.map((client, idx) => (
            <img
              src={client.logo}
              alt={client.name}
              className="client-logo"
              key={client.name}
              data-aos="fade-up"
              data-aos-delay={100 * (idx + 1)}
            />
          ))}
        </div> */}

        {/* Testimonials Carousel */}
        <div className="testimonials-carousel">
          {clients.map((client, idx) => (
            <div className="testimonial" key={client.name} data-aos="fade-up" data-aos-delay={100 * (idx + 1)}>
              <p className="testimonial-view">"{client.view}"</p>
              <div className="testimonial-person">{client.person}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}